import React from "react";
import styled from "styled-components";
import { TableHeaderColumn } from "components";

export const TableHeader = ({ sortCol, sortType, onSort = () => {} }) => {
  return (
    <Container>
      <TableHeaderColumn></TableHeaderColumn>
      <TableHeaderColumn label="Name"></TableHeaderColumn>
      <TableHeaderColumn label="Progress"></TableHeaderColumn>
      <TableHeaderColumn label="Tasks"></TableHeaderColumn>
      <TableHeaderColumn
        name="creation_time"
        label="Created Date"
        sortCol={sortCol}
        sortType={sortType}
        onSort={onSort}
      />
      <TableHeaderColumn
        name="completed_time"
        label="Completed Date"
        sortCol={sortCol}
        sortType={sortType}
        onSort={onSort}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0 0px 0 32px;
  color: white;
  font-size: ${(props) => props.theme.palette.m};
  margin: 28px 12px 15px 12px;
  & > div:nth-child(1) {
    width: 0px;
  }
  & > div:nth-child(2) {
    width: 200px;
  }
  & > div:nth-child(3) {
    width: 480px;
  }
  & > div:nth-child(4) {
    width: 200px;
  }
  & > div:nth-child(5) {
    width: 200px;
  }
  & > div:nth-child(6) {
    flex: 1;
  }
`;
